// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"ButtonWrapper_buttonsWrapper__P3nDQ"};